import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ForgotPasswordComponent } from "./page/forgot-password/forgot-password.component";

import { LoginComponent } from "./page/login/login.component";
import { RegisterComponent } from "./page/register/register.component";

const routes: Routes = [
  {
    path: "Login",
    redirectTo: "/Auth/Login",
    pathMatch: "full"
    // canActivate:[AuthGuard]
  },
  // {
  //   path: "forgotPassword/:email/:token",
  //   redirectTo: "/Auth/ForgotPassword/:email/:token",
  //   pathMatch: "full",
  // },
  {
    path: "Login",
    component: LoginComponent,
    // canActivate:[AuthGuard]
  },
  {
    path: "Register",
    component: RegisterComponent,
  },
  {
    // path: "ForgotPassword/:email/:token",
    // pathMatch: "full",
    path: "ForgotPassword",
    component: ForgotPasswordComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}

// ?email=add&token=aaa

// string?email=stephen.raj@euroland.com&token=CfDJ8PRpIcGF4p5PhnLO9EoAPz9Cj/vKkFKbato4HlOD5NVHPnXFUTmGFSHe6U4ruy7DzrHBqIthETowK/xMOdeZDqqgCO8jvF8sv6c2xqqsMGKwLThjtHHBTkQ6x/BgzKR6PlaB5W/OsVcb5Ide5uMQJQ61H7Nh4Mv/ekONLaloAqwkOC9ueB7Gqj3bmXO5leDgEQ==
